module.exports = __webpack_public_path__ + "static/media/map-marker-plus.4e96d67b.svg";